import AddIcon from '@mui/icons-material/Add';
import { Card, CardHeader, Divider } from '@mui/material';
import Button from '@mui/material/Button';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useClientFields } from '../../../sic-lib/api/hooks/useClientFields';
import { groupClientFieldsByValidationType } from '../../../sic-lib/utils/functionalReducers';
import ToggleComponents from '../../Shared/ToggleComponents/ToggleComponents';
import ClientFieldsGroup from './ClientFieldsGroup/ClientFieldsGroup';
import ClientFieldsItemCreate from './ClientFieldsItemCreate/ClientFieldsItemCreate';

function ClientFields() {
    const { classes } = useStyles();

    const { data } = useClientFields();

    const clientFields = React.useMemo(() => {
        if (!data) {
            return [];
        }
        return data || [];
    }, [data]);

    const fieldGroups = React.useMemo(() => {
        return groupClientFieldsByValidationType(clientFields);
    }, [clientFields]);

    return (
        <React.Fragment>
            <ToggleComponents>
                {(toggle, onToggleHandler) =>
                    !toggle ? (
                        <Button onClick={onToggleHandler} startIcon={<AddIcon />} sx={{ mb: 1 }}>
                            Create Custom Field
                        </Button>
                    ) : (
                        <Card>
                            <CardHeader title="Create Custom Field" />
                            <Divider />
                            <ClientFieldsItemCreate onDoneHandler={onToggleHandler} />
                        </Card>
                    )
                }
            </ToggleComponents>
            <ClientFieldsGroup fieldTitle="custom phone fields" fieldItems={fieldGroups.phone} />
            <ClientFieldsGroup fieldTitle="custom email fields" fieldItems={fieldGroups.email} />
            <ClientFieldsGroup
                fieldTitle="custom address fields"
                fieldItems={fieldGroups.address}
            />
            <ClientFieldsGroup fieldTitle="custom date fields" fieldItems={fieldGroups.date} />
            <ClientFieldsGroup
                fieldTitle="custom monetary fields"
                fieldItems={fieldGroups.dollar}
            />
            <ClientFieldsGroup fieldTitle="custom year fields" fieldItems={fieldGroups.year} />
            <ClientFieldsGroup fieldTitle="custom other fields" fieldItems={fieldGroups.other} />
        </React.Fragment>
    );
}

export default ClientFields;

const useStyles = makeStyles()((theme: Theme) => ({}));
